import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Core2Config } from '../../utils/core2-config';
import { ApiVisa } from '../../models/base/apivisa.model';
import { BaseService } from '../../templates/services/base-service.template';
import { getHttpHeader } from '../../utils/http-header.factory';

@Injectable({
  providedIn: 'root'
})
export class MerchantApiSettlementService implements BaseService {

  public apiUrl: string = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'pgw/ambank-settlement/req';

  constructor(protected readonly http: HttpClient) {}

  public settle(data: any, summaryGuid: string, { tenantCode, api_domain_url, jwt_secret }: ApiVisa): Observable<any>{
    return this.http.post(`${ api_domain_url }${ this.apiUrl }/${ tenantCode }/${ summaryGuid }`, data, getHttpHeader(jwt_secret, tenantCode));
  }
}
